import Box from '@mui/material/Box';
import NRChip from '../NRChip/NRChip';

const NRTag = ({ text, tooltipContent, style, isScope, actualScope, icon }) => {
  const getTooltipContent = () => {
    const content = [];

    if (tooltipContent) {
      content.push(tooltipContent);
    }

    if (isScope) {
      if (actualScope) {
        content.push(
          <>
            <Box tabIndex={0} component="span" sx={{ fontWeight: 700 }}>
              Actual Scope:{' '}
            </Box>
            {actualScope}
          </>
        );
      }

      content.push(
        <>
          <Box tabIndex={0} component="span" sx={{ fontWeight: 700 }}>
            Dependent Scope:{' '}
          </Box>
          The scope through which this component was introduced into the asset by one or more dependent components, based on package metadata.
        </>
      );

      content.push(
        <>
          <Box tabIndex={0} component="span" sx={{ fontWeight: 700 }}>
            Note:{' '}
          </Box>
          This reflects direct dependency links only. It does not account for transitive inheritance.
        </>
      );
    }

    return content;
  };

  const showTooltip = Boolean(tooltipContent || isScope);

  return (
    <NRChip
      label={text}
      icon={icon}
      sx={style}
      tooltipTitle={showTooltip ? text : undefined}
      tooltipContent={showTooltip ? getTooltipContent() : undefined}
    />
  );
};

export default NRTag;
